export const SET_MAXRECT = 'SET_MAXRECT';
export const RESET_MAXRECT: String = 'RESET_MAXRECT';

export interface MaxRectData {
    width: number;
    height: number;
    data: {
        id: string;
        name: string;
        origin: {
            x: number;
            y: number;
        };
    };
    x: number;
    y: number;
}

export interface MaxRectAction {
    type: typeof SET_MAXRECT;
    payload: MaxRectData[];
}

export const setMaxRect = (payload: MaxRectData[]): MaxRectAction => {
    return {
        type: SET_MAXRECT,
        payload,
    };
};

export const ResetMaxRectAction = () => {
    return {
        type: RESET_MAXRECT,
    };
};
